var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWingspanLogoBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 80 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#090706",
  d: "M53.854 0 33.086.065 15.798 30.011 26.143 48zM79.9 0 59.128.065 41.842 30.011 52.185 48zM27.812 0H.1l13.11 24.033z"
})));
export default SvgWingspanLogoBlack;